var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',{staticClass:"text-h5 grey lighten-2"},[_vm._v("\n        "+_vm._s(_vm.termo.titulo)+"\n    ")]),_c('v-card-text',{staticClass:"mt-3",domProps:{"innerHTML":_vm._s(_vm.termo.texto)}}),_c('v-divider'),_c('v-card-actions',[_c('v-spacer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }